import { IItemsUpdateAction, ItemsActionType } from ".";
import { IResult } from "../../data/data";

/**
 * When items will be updated
 * 
 * @param items
 */
export const ItemsUpdatedAction = (items: IResult[]): IItemsUpdateAction => {
    return {
        type: ItemsActionType.UPDATE,
        items
    };
}